import React from "react";
import PropTypes from "prop-types";
import styles from "components/manage-envelopes/envelope-modals.scss";
import { Modal } from "components/common/modal";
import { Button } from "components/common/button";

export const SendEnvelopeModal = ({
  coversheetUrl,
  isSendEnvelopeVisible,
  onHideSendEnvelope
}) => (
  <Modal
    isVisible={ isSendEnvelopeVisible }
    onClose={ onHideSendEnvelope }
    transitionName="send-envelope"
  >
    <h2>Not using a Squirrel Street Magic Envelope?</h2>
    <div>Mail your documents with a coversheet to the address below.</div>
    <div className={ styles.address }>
      <p><strong>Regular and Express Post</strong></p>
      <p>Squirrel Street</p>
      <p>PO Box 6488</p>
      <p>FRENCHS FOREST NSW 2086</p>
      <p>AUSTRALIA</p>
    </div>

    <div>No printer? Make a simple coversheet with your name, phone and email address!</div>
    <div className={ styles.controls }>
      <Button link onClick={ onHideSendEnvelope }>close</Button>
      <Button onClick={ () => window.open(coversheetUrl) } primary>Print Coversheet</Button>
    </div>
  </Modal>
);

SendEnvelopeModal.propTypes = {
  coversheetUrl: PropTypes.string.isRequired,
  isSendEnvelopeVisible: PropTypes.bool.isRequired,
  onHideSendEnvelope: PropTypes.func.isRequired
};



// WEBPACK FOOTER //
// ./src/js/components/manage-envelopes/send-envelope-modal.jsx